import { gql, TypedDocumentNode } from '@apollo/client';
import type { OverheadCostLineItem } from '../models/OverheadCostLineItem';

export const UPDATE_OVERHEAD_COST_LINE_ITEMS_MUTATION: TypedDocumentNode<{ updated: boolean }, { overheadCostLineItemModels: OverheadCostLineItem[] }> = gql`
  mutation UpdateOverheadCostLineItems($overheadCostLineItemModels: [OverheadCostLineItemModelInput!]!) {
    updated: updateOverheadCostLineItems(overheadCostLineItemModels: $overheadCostLineItemModels)
  }
`;